import { observable } from 'mobx';
import { SerializedData, Store } from 'bernie-core';
import { FlightsShoppingPwaFlightInformationResults } from '__generated__/api';
import Analytics = FlightsShoppingPwaFlightInformationResults.Analytics;

export class FlightInformationStore extends Store {
  @observable public loading: boolean;
  @observable public checkoutLoading: boolean;
  @observable public analytics?: Analytics;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public enableCheckoutLoading = () => {
    this.checkoutLoading = true;
    // This is a hack for safari where on pressing back button the loading bar is still visible
    // and hence we are forcing a reload to be in parity with other browsers, where the reload always happen
    // https://jira.expedia.biz/browse/FFSUAT-273
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload(true);
      }
    };
  };
}

FlightInformationStore.DEFAULTS = {
  loading: true,
  checkoutLoading: false
};
